export class NetworkError extends Error {
  status: number;

  constructor(status: number, message: string) {
    super(message);
    this.name = "NetworkError";
    this.status = status;
  }
}
